module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-a9e262cd76939a2d23e8cea51307dd3f.png";